/**
 * @author Artem Nakhodkin <artem.nakhodkin@racingpost.com>
 */

import { createStore, applyMiddleware, compose } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import thunk from 'redux-thunk';
import createLogger from 'redux-logger';
import rootReducer from './rootReducer';

/**
 * Function, that configures store and initial state
 * Adds logger as middleware in development environment
 * @param preloadedState
 */
const configureStore = (preloadedState) => {
    const middleware = [thunk];
    const logger = createLogger();
    let composeEnhancers = compose;

    if (process.env.NODE_ENV === 'development') {
        middleware.push(logger);
        composeEnhancers = composeWithDevTools;
    }

    return createStore(
        rootReducer,
        preloadedState,
        composeEnhancers(applyMiddleware(...middleware))
    );
};

export default configureStore;



// WEBPACK FOOTER //
// ./src/js/configureStore.js